$(function() {
    $('.js-onclick_submit').click(function(event) {
        event.preventDefault();
        const formid = $(this).data('form');
        const form = $('#'+formid);
        form.submit();
    });
});
